/**
 * @generated SignedSource<<19827426e947cd6a09274b959623c367>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CommentsPanel_GetShortURLMutation$variables = {
  threadId: string;
};
export type CommentsPanel_GetShortURLMutation$data = {
  readonly Comment_GetShortURL: {
    readonly url: string;
  } | null;
};
export type CommentsPanel_GetShortURLMutation = {
  response: CommentsPanel_GetShortURLMutation$data;
  variables: CommentsPanel_GetShortURLMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "threadId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "threadId",
        "variableName": "threadId"
      }
    ],
    "concreteType": "GetShortUrl",
    "kind": "LinkedField",
    "name": "Comment_GetShortURL",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentsPanel_GetShortURLMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentsPanel_GetShortURLMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "810d0cd6f3d158bdb4b840624a2c78ef",
    "id": null,
    "metadata": {},
    "name": "CommentsPanel_GetShortURLMutation",
    "operationKind": "mutation",
    "text": "mutation CommentsPanel_GetShortURLMutation(\n  $threadId: ID!\n) {\n  Comment_GetShortURL(threadId: $threadId) {\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "25833530c2847b7b318ac21f2715e556";

export default node;
